import RouteModule from "./Routes";

// add toaster
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <RouteModule />
      <ToastContainer />
    </div>
  );
}

export default App;
